{
  "CUSTOM_ROLE": {
    "HEADER": "カスタムロール",
    "LEARN_MORE": "カスタムロールについて詳しく学ぶ",
    "DESCRIPTION": "カスタムロールは、アカウントオーナーまたは管理者によって作成されるロールです。これらのロールは、担当者に割り当てて、アカウント内でのアクセス権と権限を定義できます。カスタムロールは、組織の要件に合わせて特定の権限とアクセスレベルで作成できます。",
    "COUNT": "{n} custom role | {n} custom roles",
    "HEADER_BTN_TXT": "カスタムロールを追加",
    "LOADING": "カスタムロールを取得中...",
    "SEARCH_PLACEHOLDER": "Search custom roles...",
    "NO_RESULTS": "No custom roles found matching your search",
    "SEARCH_404": "検索内容（クエリ）に一致する項目はありませんでした。",
    "PAYWALL": {
      "TITLE": "アップグレードしてカスタムロールを作成",
      "AVAILABLE_ON": "カスタムロール機能はビジネスプランおよびエンタープライズプランでのみ利用可能です。",
      "UPGRADE_PROMPT": "チーム管理、自動化、カスタム属性などの高度な機能にアクセスするためにプランをアップグレードしてください。",
      "UPGRADE_NOW": "今すぐアップグレード",
      "CANCEL_ANYTIME": "プランはいつでも変更またはキャンセルできます"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "カスタムロール機能は有料プランでのみ利用可能です。",
      "UPGRADE_PROMPT": "監査ログ、担当者キャパシティなどの高度な機能にアクセスするために有料プランにアップグレードしてください。",
      "ASK_ADMIN": "アップグレードについては管理者にお問い合わせください。"
    },
    "LIST": {
      "404": "このアカウントでは利用可能なカスタムロールはありません。",
      "TITLE": "カスタムロールの管理",
      "DESC": "カスタムロールは、アカウントオーナーまたは管理者によって作成されるロールです。これらのロールは、担当者に割り当てて、アカウント内でのアクセス権と権限を定義できます。カスタムロールは、組織の要件に合わせて特定の権限とアクセスレベルで作成できます。",
      "TABLE_HEADER": {
        "NAME": "名前",
        "DESCRIPTION": "説明",
        "PERMISSIONS": "権限",
        "ACTIONS": "操作"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "すべての会話を管理",
      "CONVERSATION_UNASSIGNED_MANAGE": "未割り当ての会話と自分に割り当てられた会話を管理",
      "CONVERSATION_PARTICIPATING_MANAGE": "参加中の会話と自分に割り当てられた会話を管理",
      "CONTACT_MANAGE": "連絡先を管理",
      "REPORT_MANAGE": "レポートを管理",
      "KNOWLEDGE_BASE_MANAGE": "ナレッジベースを管理"
    },
    "FORM": {
      "NAME": {
        "LABEL": "名前",
        "PLACEHOLDER": "名前を入力してください。",
        "ERROR": "名前が必須です。"
      },
      "DESCRIPTION": {
        "LABEL": "説明",
        "PLACEHOLDER": "説明を入力してください。",
        "ERROR": "説明が必須です。"
      },
      "PERMISSIONS": {
        "LABEL": "権限",
        "ERROR": "権限が必須です。"
      },
      "CANCEL_BUTTON_TEXT": "キャンセル",
      "API": {
        "ERROR_MESSAGE": "Woot サーバーに接続できませんでした。後でもう一度お試しください。"
      }
    },
    "ADD": {
      "TITLE": "カスタムロールを追加",
      "DESC": "カスタムロールは、組織の要件に合わせて特定の権限とアクセスレベルでロールを作成できます。",
      "SUBMIT": "送信",
      "API": {
        "SUCCESS_MESSAGE": "カスタムロールが正常に追加されました。"
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "編集",
      "TITLE": "カスタムロールを編集",
      "DESC": "カスタムロールは、組織の要件に合わせて特定の権限とアクセスレベルでロールを作成できます。",
      "SUBMIT": "更新",
      "API": {
        "SUCCESS_MESSAGE": "カスタムロールが正常に更新されました。"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "削除",
      "API": {
        "SUCCESS_MESSAGE": "カスタムロールが正常に削除されました。",
        "ERROR_MESSAGE": "Woot サーバーに接続できませんでした。後でもう一度お試しください。"
      },
      "CONFIRM": {
        "TITLE": "削除の確認",
        "MESSAGE": "削除してもよろしいですか？",
        "YES": "はい、削除します",
        "NO": "いいえ、保持します"
      }
    }
  }
}
